import { render } from "./px-bottom-bar.vue?vue&type=template&id=2efe9118&scoped=true&ts=true"
import script from "./px-bottom-bar.vue?vue&type=script&lang=ts"
export * from "./px-bottom-bar.vue?vue&type=script&lang=ts"

import "./px-bottom-bar.vue?vue&type=style&index=0&id=2efe9118&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efe9118"]])

export default __exports__